import { render, staticRenderFns } from "./AvatarImageModal.vue?vue&type=template&id=0cec8fb2&scoped=true&"
import script from "./AvatarImageModal.vue?vue&type=script&lang=js&"
export * from "./AvatarImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cec8fb2",
  null
  
)

export default component.exports